// apps/scheduler-worker/src/components/BottomNav.tsx
import { NavLink } from 'react-router-dom';
import { ListTodo, Clock, CalendarDays, User } from 'lucide-react';
import { cn } from 'scheduler-ui';

interface NavItemProps {
  to: string;
  icon: React.ReactNode;
  label: string;
}

function NavItem({ to, icon, label }: NavItemProps) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        cn(
          'flex flex-col items-center justify-center flex-1 py-2 text-xs font-medium transition-colors',
          isActive
            ? 'text-blue-600'
            : 'text-gray-500 hover:text-gray-900'
        )
      }
    >
      {icon}
      <span className="mt-1">{label}</span>
    </NavLink>
  );
}

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 inset-x-0 h-16 border-t bg-white flex items-center safe-area-bottom">
      <NavItem to="/" icon={<ListTodo className="h-6 w-6" />} label="Tasks" />
      <NavItem to="/time" icon={<Clock className="h-6 w-6" />} label="Time" />
      <NavItem to="/schedule" icon={<CalendarDays className="h-6 w-6" />} label="Schedule" />
      <NavItem to="/profile" icon={<User className="h-6 w-6" />} label="Profile" />
    </nav>
  );
}
